/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { TrademarkRequestList200ResponseDataTrademarkRequestsInner } from './TrademarkRequestList200ResponseDataTrademarkRequestsInner'
import {
  TrademarkRequestList200ResponseDataTrademarkRequestsInnerFromJSON,
  TrademarkRequestList200ResponseDataTrademarkRequestsInnerFromJSONTyped,
  TrademarkRequestList200ResponseDataTrademarkRequestsInnerToJSON,
} from './TrademarkRequestList200ResponseDataTrademarkRequestsInner'

/**
 *
 * @export
 * @interface TrademarkRequestList200ResponseData
 */
export interface TrademarkRequestList200ResponseData {
  /**
   *
   * @type {Array<TrademarkRequestList200ResponseDataTrademarkRequestsInner>}
   * @memberof TrademarkRequestList200ResponseData
   */
  trademarkRequests: Array<TrademarkRequestList200ResponseDataTrademarkRequestsInner>
}

/**
 * Check if a given object implements the TrademarkRequestList200ResponseData interface.
 */
export function instanceOfTrademarkRequestList200ResponseData(
  value: object
): value is TrademarkRequestList200ResponseData {
  if (
    !('trademarkRequests' in value) ||
    value['trademarkRequests'] === undefined
  )
    return false
  return true
}

export function TrademarkRequestList200ResponseDataFromJSON(
  json: any
): TrademarkRequestList200ResponseData {
  return TrademarkRequestList200ResponseDataFromJSONTyped(json, false)
}

export function TrademarkRequestList200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TrademarkRequestList200ResponseData {
  if (json == null) {
    return json
  }
  return {
    trademarkRequests: (json['trademarkRequests'] as Array<any>).map(
      TrademarkRequestList200ResponseDataTrademarkRequestsInnerFromJSON
    ),
  }
}

export function TrademarkRequestList200ResponseDataToJSON(
  value?: TrademarkRequestList200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    trademarkRequests: (value['trademarkRequests'] as Array<any>).map(
      TrademarkRequestList200ResponseDataTrademarkRequestsInnerToJSON
    ),
  }
}
